export default "__VITE_ASSET__DZP_EFPc__"